import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    userInfoList: [],
    meetingList: [],
    meetingInfo: {},
    meetingId: "",
    meritList: [],
    donationDetail: {},
    addUserInfo:{}
  },
  mutations: {
    updateMeetingList(state, data) {
      state.meetingList = data
    },
    updateMeetingInfo(state, data) {
      state.meetingInfo = data
    },
    updateMeetingId(state, data) {
      state.meetingId = data
    },
    updateUserInfoList(state, data) {
      state.userInfoList = data
    },
    updateMeritList(state, data) {
      state.meritList = data
    },
    updateDonationDetail(state, data) {
      state.donationDetail = data
    },
    updateAddUserInfo(state, data) {
      state.addUserInfo = data
    },
  },
  actions: {},
  getters: {},
})
export default store
